var map = {
  "./pl.messages.tsx": [
    "49448",
    [
      6775
    ]
  ],
  "./cs.messages.tsx": [
    "92590",
    [
      2297
    ]
  ],
  "./en.messages.tsx": [
    "19831",
    [
      4130
    ]
  ],
  "./hu.messages.tsx": [
    "90355",
    [
      8662
    ]
  ],
  "./de.messages.tsx": [
    "38847",
    [
      4458
    ]
  ],
  "./it.messages.tsx": [
    "93249",
    [
      9064
    ]
  ],
  "./sk.messages.tsx": [
    "98022",
    [
      4657
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 81920;
module.exports = __rspack_async_context;
